<template>
    <!-- 填报意向 -->
    <div class="intention_box">
        <div class="userintente">
            <div class="userintentetitle"><i class="iconfont">&#xe68e;</i> 防退档参数</div>
            <div class="userintentebox">
                <div class="uibox">
                    <div class="uitip">外语语种：</div>
                    <el-select v-model="SubmitData.ForeignLanguageType" clearable filterable placeholder="请选择" style="margin:20px 0 0 20px;width:300px;">
                        <el-option label="请选择" value></el-option>
                        <el-option v-for="item in ForeignLanguageTypeArr" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">语文成绩：</div>
                    <el-input maxlength="3" placeholder="语文成绩" v-model="SubmitData.ChineseScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">数学成绩：</div>
                    <el-input maxlength="3" placeholder="数学成绩" v-model="SubmitData.MathScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">外语成绩：</div>
                    <el-input maxlength="3" placeholder="外语成绩" v-model="SubmitData.FLScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">物理成绩：</div>
                    <el-input maxlength="3" placeholder="物理成绩" v-model="SubmitData.PhysicScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">化学成绩：</div>
                    <el-input maxlength="3" placeholder="化学成绩" v-model="SubmitData.ChemistryScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">生物成绩：</div>
                    <el-input maxlength="3" placeholder="生物成绩" v-model="SubmitData.BiologyScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">历史成绩：</div>
                    <el-input maxlength="3" placeholder="历史成绩" v-model="SubmitData.HistoryScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">地理成绩：</div>
                    <el-input maxlength="3" placeholder="地理成绩" v-model="SubmitData.GeographyScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">政治成绩：</div>
                    <el-input maxlength="3" placeholder="政治成绩" v-model="SubmitData.PoliticsScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">技术成绩：</div>
                    <el-input maxlength="3" placeholder="技术成绩" v-model="SubmitData.TechScore" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">身高：</div>
                    <el-input maxlength="5" placeholder="身高" v-model="SubmitData.Height" clearable onkeyup="this.value=this.value.replace(/\D|^0/g,'')" style="margin:20px 0 0 20px;width:300px;"></el-input>（单位：厘米）
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">体重指数：</div>
                    <el-input maxlength="5" placeholder="体重指数" v-model="SubmitData.BodyMassIndex" clearable onkeyup="this.value=this.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="margin:20px 0 0 20px;width:300px;"></el-input>（请安身体质量指数（BMI）填写，例：20.5）
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">裸眼视力：</div>
                    <el-input maxlength="3" placeholder="裸眼视力" v-model="SubmitData.VisualAcuity" clearable onkeyup="this.value=this.value.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1')" style="margin:20px 0 0 20px;width:300px;"></el-input>（请按照五分记录法填写，例：5.0）
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">婚姻状况：</div>
                    <el-select v-model="SubmitData.MaritalStatus" placeholder="请选择" style="margin:20px 0 0 20px;width:300px;">
                        <el-option label="请选择" value></el-option>
                        <el-option label="未婚" value="未婚"></el-option>
                        <el-option label="已婚" value="已婚"></el-option>
                    </el-select>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">是否色盲色弱：</div>
                    <el-radio-group v-model="SubmitData.IsColorBlindness" style="margin:33px 0 0 20px;">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">是否患有重大疾病：</div>
                    <el-radio-group v-model="SubmitData.IsCriticalIllness" style="margin:33px 0 0 20px;">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">是否政审不合格</div>
                    <el-radio-group v-model="SubmitData.IsZhengShenBuHeGe" style="margin:33px 0 0 20px;">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">左撇子：</div>
                    <el-radio-group v-model="SubmitData.IsZuoPieZi" style="margin:33px 0 0 20px;">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">政治面貌：</div>
                    <el-select v-model="SubmitData.ZhengZhiMianMao" placeholder="请选择" style="margin:20px 0 0 20px;width:300px;">
                        <el-option label="请选择" value></el-option>
                        <el-option label="群众" value="群众"></el-option>
                        <el-option label="共青团员" value="共青团员"></el-option>
                        <el-option label="共产党员" value="共产党员"></el-option>
                        <el-option label="预备共产党员" value="预备共产党员"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                    </el-select>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <div class="submitbtn" @click.prevent="SubmitIntention()">保 存</div>
    </div>
</template>
<script>
import API from "@/api/config";
export default{
    data(){
        return {
            loading:false,
            SubmitData:{
                ForeignLanguageType: "",
                ChineseScore: null,
                MathScore: null,
                FLScore: null,
                PhysicScore: null,
                ChemistryScore: null,
                BiologyScore: null,
                HistoryScore: null,
                GeographyScore: null,
                PoliticsScore: null,
                TechScore: null,
                Height: null,
                BodyMassIndex: null,
                VisualAcuity: null,
                MaritalStatus: "",
                IsColorBlindness: false,
                IsCriticalIllness: false,
                IsZhengShenBuHeGe: null,
                IsZuoPieZi: null,
                ZhengZhiMianMao: ""
            },
            ForeignLanguageTypeArr:[
                {Value: '英语', Text: "英语"},
                {Value: '俄语', Text: "俄语"},
                {Value: '德语', Text: "德语"},
                {Value: '法语', Text: "法语"},
                {Value: '西班牙语', Text: "西班牙语"},
                {Value: '阿拉伯语', Text: "阿拉伯语"},
                {Value: '日语', Text: "日语"},
                {Value: '波斯语', Text: "波斯语"},
                {Value: '朝鲜语', Text: "朝鲜语"},
                {Value: '菲律宾语', Text: "菲律宾语"},
                {Value: '塔玛齐格特语', Text: "塔玛齐格特语"},
                {Value: '爪哇语', Text: "爪哇语"},
                {Value: '旁遮普语', Text: "旁遮普语"},
                {Value: '梵语巴利语', Text: "梵语巴利语"},
                {Value: '印度尼西亚语', Text: "印度尼西亚语"},
                {Value: '印地语', Text: "印地语"},
                {Value: '柬埔寨语', Text: "柬埔寨语"},
                {Value: '老挝语', Text: "老挝语"},
                {Value: '缅甸语', Text: "缅甸语"},
                {Value: '马来语', Text: "马来语"},
                {Value: '蒙古语', Text: "蒙古语"},
                {Value: '僧伽罗语', Text: "僧伽罗语"},
                {Value: '泰语', Text: "泰语"},
                {Value: '乌尔都语', Text: "乌尔都语"},
                {Value: '希伯来语', Text: "希伯来语"},
                {Value: '越南语', Text: "越南语"},
                {Value: '豪萨语', Text: "豪萨语"},
                {Value: '斯瓦希里语', Text: "斯瓦希里语"},
                {Value: '阿尔巴尼亚语', Text: "阿尔巴尼亚语"},
                {Value: '保加利亚语', Text: "保加利亚语"},
                {Value: '波兰语', Text: "波兰语"},
                {Value: '捷克语', Text: "捷克语"},
                {Value: '斯洛伐克语', Text: "斯洛伐克语"},
                {Value: '罗马尼亚语', Text: "罗马尼亚语"},
                {Value: '葡萄牙语', Text: "葡萄牙语"},
                {Value: '瑞典语', Text: "瑞典语"},
                {Value: '塞尔维亚语', Text: "塞尔维亚语"},
                {Value: '土耳其语', Text: "土耳其语"},
                {Value: '希腊语', Text: "希腊语"},
                {Value: '匈牙利语', Text: "匈牙利语"},
                {Value: '意大利语', Text: "意大利语"},
                {Value: '泰米尔语', Text: "泰米尔语"},
                {Value: '普什图语', Text: "普什图语"},
                {Value: '世界语', Text: "世界语"},
                {Value: '孟加拉语', Text: "孟加拉语"},
                {Value: '尼泊尔语', Text: "尼泊尔语"},
                {Value: '克罗地亚语', Text: "克罗地亚语"},
                {Value: '荷兰语', Text: "荷兰语"},
                {Value: '芬兰语', Text: "芬兰语"},
                {Value: '乌克兰语', Text: "乌克兰语"},
                {Value: '挪威语', Text: "挪威语"},
                {Value: '丹麦语', Text: "丹麦语"},
                {Value: '冰岛语', Text: "冰岛语"},
                {Value: '爱尔兰语', Text: "爱尔兰语"},
                {Value: '拉脱维亚语', Text: "拉脱维亚语"},
                {Value: '立陶宛语', Text: "立陶宛语"},
                {Value: '斯洛文尼亚语', Text: "斯洛文尼亚语"},
                {Value: '爱沙尼亚语', Text: "爱沙尼亚语"},
                {Value: '马耳他语', Text: "马耳他语"},
                {Value: '哈萨克语', Text: "哈萨克语"},
                {Value: '乌兹别克语', Text: "乌兹别克语"},
                {Value: '祖鲁语', Text: "祖鲁语"},
                {Value: '拉丁语', Text: "拉丁语"},
                {Value: '商务英语', Text: "商务英语"},
                {Value: '阿姆哈拉语', Text: "阿姆哈拉语"},
                {Value: '吉尔吉斯语', Text: "吉尔吉斯语"},
                {Value: '索马里语', Text: "索马里语"},
                {Value: '土库曼语', Text: "土库曼语"},
                {Value: '加泰罗尼亚语', Text: "加泰罗尼亚语"},
                {Value: '约鲁巴语', Text: "约鲁巴语"},
                {Value: '亚美尼亚语', Text: "亚美尼亚语"},
                {Value: '马达加斯加语', Text: "马达加斯加语"},
                {Value: '格鲁吉亚语', Text: "格鲁吉亚语"},
                {Value: '阿塞拜疆语', Text: "阿塞拜疆语"},
                {Value: '阿非利卡语', Text: "阿非利卡语"},
                {Value: '马其顿语', Text: "马其顿语"},
                {Value: '塔吉克语', Text: "塔吉克语"},
                {Value: '茨瓦纳语', Text: "茨瓦纳语"},
                {Value: '恩德贝莱语', Text: "恩德贝莱语"},
                {Value: '科摩罗语', Text: "科摩罗语"},
                {Value: '克里奥尔语', Text: "克里奥尔语"},
                {Value: '绍纳语', Text: "绍纳语"},
                {Value: '提格雷尼亚语', Text: "提格雷尼亚语"},
                {Value: '白俄罗斯语', Text: "白俄罗斯语"},
                {Value: '毛利语', Text: "毛利语"},
                {Value: '汤加语', Text: "汤加语"},
                {Value: '萨摩亚语', Text: "萨摩亚语"},
                {Value: '库尔德语', Text: "库尔德语"},
                {Value: '比斯拉马语', Text: "比斯拉马语"},
                {Value: '达里语', Text: "达里语"},
                {Value: '德顿语', Text: "德顿语"},
                {Value: '迪维希语', Text: "迪维希语"},
                {Value: '斐济语', Text: "斐济语"},
                {Value: '库克群岛毛利语', Text: "库克群岛毛利语"},
                {Value: '隆迪语', Text: "隆迪语"},
                {Value: '卢森堡语', Text: "卢森堡语"},
                {Value: '卢旺达语', Text: "卢旺达语"},
                {Value: '纽埃语', Text: "纽埃语"},
                {Value: '皮金语', Text: "皮金语"},
                {Value: '切瓦语', Text: "切瓦语"},
                {Value: '桑戈语', Text: "桑戈语"},
                {Value: '塞苏陀语', Text: "塞苏陀语"}
            ]
        }
    },
    mounted(){
        this.GetUserAntiRollbackDetail();
    },
    methods:{
        //获取防退档参数
        GetUserAntiRollbackDetail(){
            API.Personal.GetUserAntiRollbackDetail().then(res => {
                if (res.Code==0&&res.Data) {
                    this.SubmitData = res.Data;
                }
            })
        },
        
        //提交防退档参数
        SubmitIntention(){
            this.loading = this.$loading({
                lock: false,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                color: '#000'
            });
            API.Personal.SaveUserAntiRollback(this.SubmitData).then(res=>{
              if(res.Code==0){
                this.$message.success("保存成功！");
              }
              else{
                this.$message.error(res.Message);
              }
              this.loading.close()
            });
        }
    }
}
</script>
<style scoped lang="less">
.intention_box{
    .userintente{
        border-radius: 5px;
        margin: 20px 20px 0;
        .userintentetitle{
            text-indent: 10px;
            line-height: 40px;
            height: 40px;
            color: #636262;
            font-size: 14px;
            background-color: #cfcfcf;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
        }
        .userintentebox{
            border: 1px solid #ddd;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            .uibox{
                border-top: 1px solid #ddd;
                position: relative;
                color: #555;
                font-size: 14px;
                .uitip{
                    width: 150px;
                    float: left;
                    color: #666;
                    font-size: 14px;
                    text-align: right;
                    line-height:80px;
                }
            }
        }
    }
    .submitbtn{
        width: 200px;
        height: 42px;
        margin-left: 10px;
        text-align: center;
        background-color: rgba(var(--themecolor),0.8);
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 42px;
        margin: 30px auto;
        font-weight: bold;
        &:hover{
            cursor: pointer;
            background-color: rgba(var(--themecolor),1);
        }
    }
}
</style>